import React, { useEffect } from 'react';

import StickyHeader from '../../components/StickyHeader/StickyHeader';
import SessionHeader from '../../components/Header/SessionHeader';
import Footer from '../../components/Footer/Footer';
import withFeatureFlags from '../../components/FeatureFlags/withFeatureFlags'
import SiteDown from '../../components/SiteDown/SiteDown';
import OutOfHours from '../../components/LiveChat/OutOfHours';
import ChatDownTime from '../../components/LiveChat/ChatDownTime';
import {useUnifiedAnalytics} from "../../contexts/AnalyticsWrapper";

/** @type {import('./SessionTypes').SessionComponent} */
const SessionLayout = ({ children, featureEnabled }) => {
    const analytics = useUnifiedAnalytics();

    useEffect(() => {
        let fullPath = window.location.pathname; // Get the pathname
        let pathName = fullPath.split('/').pop();
        if (analytics)
            analytics.trackAnalyticsPageEvent('generic load',{},'',`Investec-Save-secure|page_load|${pathName}`);
    }, []);

    if (featureEnabled("DashboardOffline")) {
        return (
            <SiteDown />
        );
    }
    return (
        <div className='product-layout' style={{ height: '100%',
            display: 'flex',
            flexDirection: 'column'}}>
            <StickyHeader>
                <SessionHeader />
            </StickyHeader>
            <div className='product-layout__content'
                 style={{display: 'flex',
                         flexDirection: 'row',
                         justifyContent: 'center',
                         alignItems: 'center',
                         flexGrow: 1
                     }}>
                {children}
            </div>
            <Footer noBorder />
            <OutOfHours />
            <ChatDownTime />
        </div>
    );
};

export default withFeatureFlags(SessionLayout);

